import React from 'react';
import CustomMarkdownRenderer from './CustomMarkdownRenderer';
import StructuredEvaluationRenderer from './StructuredEvaluationRenderer';

const HybridEvaluationRenderer = ({ evaluationResult }) => {
  // Parse the result if it's a string
  let parsedResult;
  try {
    parsedResult = typeof evaluationResult === 'string' 
      ? JSON.parse(evaluationResult) 
      : evaluationResult;
  } catch (error) {
    console.error("Error parsing evaluation result:", error);
    // If parsing fails, treat as plain markdown
    return <CustomMarkdownRenderer markdownContent={evaluationResult} />;
  }
  
  // Check if we have the hybrid format (both markdown and structured data)
  if (parsedResult && (parsedResult.markdown || parsedResult.structured)) {
    // If we have structured data, use the structured renderer
    if (parsedResult.structured) {
      try {
        return <StructuredEvaluationRenderer evaluationData={parsedResult.structured} />;
      } catch (error) {
        console.error("Error rendering structured data:", error);
        // Fall back to markdown if structured rendering fails
        if (parsedResult.markdown) {
          return <CustomMarkdownRenderer markdownContent={parsedResult.markdown} />;
        }
      }
    }
    
    // Otherwise fall back to markdown
    if (parsedResult.markdown) {
      return <CustomMarkdownRenderer markdownContent={parsedResult.markdown} />;
    }
  }
  
  // Legacy support for plain markdown string or if all else fails
  return <CustomMarkdownRenderer markdownContent={
    typeof evaluationResult === 'string' ? evaluationResult : JSON.stringify(evaluationResult)
  } />;
};

export default HybridEvaluationRenderer;